import React from 'react';
import { Users } from 'lucide-react';
import {
    PieChart,
    Pie,
    Cell,
    Tooltip,
    ResponsiveContainer,
} from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const RevenueDistribution = ({ revenueBreakdown }) => {
    return (
        <Card className="group relative overflow-hidden bg-[hsl(var(--card))] text-[hsl(var(--card-foreground))] border-[hsl(var(--border))] hover:border-[hsl(var(--border))]/40 rounded-xl">
            <CardHeader>
                <CardTitle className="flex items-center gap-2 text-sm">
                    <div className="p-2 rounded-lg bg-primary/5 group-hover:bg-primary/10 dark:group-hover:bg-primary/20 transition-colors">
                        <Users className="h-4 w-4 text-primary/50 group-hover:text-primary/80 dark:group-hover:text-primary/90 transition-colors" />
                    </div>
                    <span className="text-foreground/90 dark:text-foreground/80 font-medium">Revenue Distribution</span>
                </CardTitle>
            </CardHeader>
            <CardContent>
                <div className="grid grid-cols-2 gap-4">
                    <div className="h-[200px]">
                        <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                                <Pie
                                    data={revenueBreakdown}
                                    cx="50%"
                                    cy="50%"
                                    innerRadius={60}
                                    outerRadius={80}
                                    paddingAngle={4}
                                    dataKey="value"
                                >
                                    {revenueBreakdown.map((entry, index) => (
                                        <Cell
                                            key={`cell-${index}`}
                                            fill={index === 0 ? 'hsl(var(--primary) / 0.7)' : 'hsl(var(--primary) / 0.4)'}
                                        />
                                    ))}
                                </Pie>
                                <Tooltip
                                    contentStyle={{
                                        backgroundColor: 'hsl(var(--card) / 0.8)',
                                        border: '1px solid hsl(var(--border) / 0.1)',
                                        borderRadius: '8px',
                                        boxShadow: '0 8px 24px -12px hsl(var(--primary) / 0.2)',
                                    }}
                                    formatter={(value) => `$${Math.round(value).toLocaleString()}`}
                                />
                            </PieChart>
                        </ResponsiveContainer>
                    </div>
                    <div className="flex flex-col justify-center space-y-4">
                        {revenueBreakdown.map((item, index) => (
                            <div key={index} className="flex items-center gap-3">
                                <div className="p-2 rounded-lg bg-primary/5 group-hover:bg-primary/10 transition-colors">
                                    <item.icon className="h-4 w-4 text-primary/50 group-hover:text-primary/80 transition-colors" />
                                </div>
                                <div>
                                    <div className="text-sm font-medium text-foreground/90">{item.name}</div>
                                    <div className="text-xs text-muted-foreground/60">
                                        ${Math.round(item.value).toLocaleString()}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </CardContent>
        </Card>
    );
};

export default RevenueDistribution; 